import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { getInputFieldHeightValue, InputFieldBaseProps } from "../../../util/inputFieldBaseProps";
import { Clickable } from "../../clickable";
import { formInputTheme } from "../../textinput/styled/formInputTheme";
import { selectV2Theme } from "./selectV2Theme";

export interface SelectButtonProps extends InputFieldBaseProps {
    hasContentBefore: boolean;
    hideDropdownArrow: boolean;
    isClearable: boolean;
    themeMode: RequiredThemeKeys;
}

/* This was originally added because the action buttons (clear and the toggle) sit on top of the real button element. If we don't add padding, long selections will appear underneath those buttons. */
const computeRightPadding = (props: SelectButtonProps) => {
    if (props.hideDropdownArrow && !props.isClearable) {
        return "0";
    } else if (props.hideDropdownArrow || !props.isClearable) {
        return "32px";
    } else {
        return "60px";
    }
};

export const SelectButton = styled(Clickable)<SelectButtonProps>`
    padding: 0;
    padding-left: ${(props) => (props.hasContentBefore ? "0" : selectV2Theme.input.padding.left(props.themeMode))};
    padding-right: ${computeRightPadding};
    height: ${({ themeMode, inputFieldHeight }) =>
        formInputTheme.height[getInputFieldHeightValue(themeMode, inputFieldHeight)](themeMode)}px;
    width: 100%;

    position: relative;
    display: flex;
    align-items: center;

    border: 0px;
    background-color: transparent;
    cursor: inherit;
    overflow-wrap: break-word;
    color: var(--sds--form--color--value, inherit);
`;
